<template>
  <div class="custom-dropdown">
    <div class="content dropdown-title" :class="isSubMenuOpen ? 'dropdown-title--dark' : ''"
      @click="selectNavItemClick($props.route, $event)">
      {{ $props.title }}
      <div class="content">
        <div v-if="items.length"
          :class="['custom-dropdown--item-container', { 'custom-dropdown--item-container--open': isSubMenuOpen }]">
          <div class="custom-dropdown--item-wrapper">
            <div v-for="(item, index) in items" :key="index">
              <div v-show="onCheckPreview(item.visible)" data-is-dropdown-item="true" class="dropdown-item"
                :class="verifyIfIsDisabled(item) && 'isDisabled'" @click="onClickHandler(item)">
                {{ item.label }}
                <div :class="getClassNew(item.featureName)"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isTitleNew()" class="dropdown-new"></div>
    <div class="arrow-up" :class="{ 'arrow-up--open': isSubMenuOpen }" @click="onExpandSubMenu()"></div>
    <div v-if="items.length" class="arrow-down" :class="{ 'arrow-down--open': isSubMenuOpen }"
      @click="onExpandSubMenu()"></div>
  </div>
</template>

<!-- eslint-disable no-unused-vars -->
<script>
import { getNewByName } from "../../utils/news/news-utils";

export default {
  props: ["title", "items", "route", "active"],
  data() {
    return {
      isSubMenuOpen: false,
    };
  },
  created() {
    this.$root.$on('dropdown-opened', this.handleDropdownOpened);
  },
  beforeDestroy() {
    this.$root.$off('dropdown-opened', this.handleDropdownOpened);
  },
  methods: {
    handleDropdownOpened(openedTitle) {
      if (this.title !== openedTitle) {
        this.isSubMenuOpen = false;
      }
    },
    onCheckPreview(value) {
      return value == null || value == undefined ? true : value;
    },
    isTitleNew() {
      return this.$props.items.some((i) => {
        if (getNewByName(i.featureName)) return true;
        return false;
      });
    },
    getClassNew(featureName) {
      const currentNew = getNewByName(featureName);
      if (currentNew) {
        return "dropdown-new";
      }
      return;
    },
    verifyIfIsDisabled(item) {
      return item.isDisabled?.();
    },
    onClickHandler(item) {
      try {
        item.action && item.action.call(item);
        this.isSubMenuOpen = false;
        this.$emit("item-clicked");
      } catch (error) {
        console.error(
          "Error on onClickHandler: trying to execute functionHanlder",
          error
        );
      }
    },
    selectNavItemClick(item, e) {
      if (e?.target?.dataset?.isDropdownItem) return;
      this.$router.push({ path: item, replace: true });
      this.$emit("item-clicked");
    },
    onExpandSubMenu() {
      if (!this.isSubMenuOpen) {
        this.$root.$emit('dropdown-opened', this.title);
      }
      this.isSubMenuOpen = !this.isSubMenuOpen;
    }
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding-top: 2rem;
}

.arrow-up {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid var(--dark-0);
  display: none;
  margin-left: 0.5rem;

  /* Área de clique expandida (Touch Target de ~40x40px) */
  position: relative;
  cursor: pointer;

  &::after {
    content: '';
    position: absolute;
    top: -20px;
    right: -20px;
    bottom: -20px;
    left: -20px;
  }

  @media screen and (max-width: 816px) {
    display: none;
  }
}

.arrow-down {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid var(--grey-1);
  margin-left: 0.5rem;

  /* Área de clique expandida (Touch Target de ~40x40px) */
  position: relative;
  cursor: pointer;

  &::after {
    content: '';
    position: absolute;
    top: -20px;
    right: -20px;
    bottom: -20px;
    left: -20px;
  }
}

.custom-dropdown {
  position: relative;
  display: flex;
  align-items: center;

  &--item-container {
    /* Desktop Animável - Hardware Accelerated */
    visibility: hidden;
    opacity: 0;
    transform: translateY(-10px);
    position: absolute;
    padding: 1rem 0;
    display: flex;
    flex-direction: column;
    background: white;
    transition: opacity 0.3s ease, transform 0.3s ease, visibility 0.3s;
    will-change: transform, opacity;
    white-space: nowrap;
    z-index: 10;
    pointer-events: none;
    top: 100%;

    @media screen and (max-width: 816px) {
      /* Mobile base - Transição de altura via CSS Grid */
      display: grid;
      grid-template-rows: 0fr;
      transition: grid-template-rows 0.3s ease-in-out, padding 0.3s ease-in-out;

      visibility: visible;
      opacity: 1;
      transform: none;
      position: relative;
      width: 100%;
      background: transparent;
      padding: 0;
      pointer-events: auto;
    }
  }

  &--item-wrapper {
    display: flex;
    flex-direction: column;
    min-height: 0;

    @media screen and (max-width: 816px) {
      overflow: hidden;
      /* Necessário para o hack do grid no mobile */
    }
  }

  transition: all 0.3s ease-in-out;

  &:hover &--item-container {
    @media screen and (min-width: 817px) {
      visibility: visible;
      opacity: 1;
      transform: translateY(0);
      color: var(--dark-0);
      pointer-events: auto;
    }
  }

  &:hover .arrow-up {
    @media screen and (min-width: 817px) {
      display: initial;
    }
  }

  &:hover .arrow-down {
    @media screen and (min-width: 817px) {
      display: none;
    }
  }

  /* Mobile specific toggling via class */
  &--item-container--open {
    @media screen and (max-width: 816px) {
      grid-template-rows: 1fr;
    }
  }

  .arrow-up--open {
    @media screen and (max-width: 816px) {
      display: block !important;
      margin-bottom: auto;
      margin-top: 5px;
    }
  }

  .arrow-down--open {
    @media screen and (max-width: 816px) {
      display: none !important;
    }
  }
}

.arrow-up--open {
  border-bottom-color: var(--green-3);
}

.dropdown-title {
  color: var(--grey-1);

  &--dark {
    color: var(--green-3);
  }

  &:hover {
    color: var(--dark-0);
  }
}

.dropdown-item {
  display: flex;
  align-items: center;
  padding: 0.5rem 2rem;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;

  &:hover {
    color: var(--primary);
    background-color: rgba(0, 128, 0, 0.08);
  }
}

.isDisabled {
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.5;
  text-decoration: none;
}

.dropdown-new {
  margin-bottom: 14px;
  border-radius: 5px;
  top: 28px;
  left: 1082px;
  width: 10px;
  height: 10px;
  background: #b1d34b 0% 0% no-repeat padding-box;
  opacity: 1;
}
</style>
<style>
@media screen and (max-width: 816px) {
  .nav-item {
    width: 100%;
    background-color: white;
    border-radius: 10px;
  }

  .shadow-sm {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }

  li.nav-item {
    margin-bottom: 5px;
  }

  .custom-dropdown {
    align-items: flex-start;
    padding-top: 0.8rem;
    padding-bottom: 0.8rem;
  }

  .custom-dropdown .arrow-down,
  .custom-dropdown .arrow-up {
    margin-left: auto;
  }

  .custom-dropdown .content {
    padding-top: 0;
  }

  .nav-item a.nav-link {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }

  .dropdown-item {
    padding: 1.4rem 2rem !important;
    padding-left: 0 !important;
  }
}
</style>
